module.exports = __webpack_public_path__ + "static/media/about_pc_5.397921aa.png";